document.documentElement.className = (document.documentElement.className + ' js'); 